import React from "react";
import { useTranslation } from "@root/misc/useTranslation";

export const StatsIconLegend = () => {
  const { t } = useTranslation();

  return (
    <div className="neo__lineupField__statsIconLegend">
      <div className="neo__lineupField__statsIconLegend__label">
        {t("lineup.stats_icon_legend.label")}
      </div>
      <div className="neo__lineupField__statsIconLegend__entries">
        <div className="neo__lineupField__statsIconLegend__entry">
          <div className="neo__lineupField__statsIconLegend__entry__icon neo__lineupField__statsIconLegend__entry__icon--scoreSum" />
          <div className="neo__lineupField__statsIconLegend__entry__text">
            {t("lineup.stats_icon_legend.score_sum")}
          </div>
        </div>
        <div className="neo__lineupField__statsIconLegend__entry">
          <div className="neo__lineupField__statsIconLegend__entry__icon neo__lineupField__statsIconLegend__entry__icon--prevScore" />
          <div className="neo__lineupField__statsIconLegend__entry__text">
            {t("lineup.stats_icon_legend.prev_score")}
          </div>
        </div>
        <div className="neo__lineupField__statsIconLegend__entry">
          <div className="neo__lineupField__statsIconLegend__entry__icon neo__lineupField__statsIconLegend__entry__icon--percPicked" />
          <div className="neo__lineupField__statsIconLegend__entry__text">
            {t("lineup.stats_icon_legend.prec_picked")}
          </div>
        </div>
      </div>
    </div>
  );
};
